import { render, staticRenderFns } from "./HealthScore.vue?vue&type=template&id=09401a8e&scoped=true"
import script from "./HealthScore.vue?vue&type=script&lang=js"
export * from "./HealthScore.vue?vue&type=script&lang=js"
import style0 from "./HealthScore.vue?vue&type=style&index=0&id=09401a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09401a8e",
  null
  
)

export default component.exports